module.exports = __webpack_public_path__ + "img/HR42252496579.020eabfe.png";